import React from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import { CUPOS_SUBNAV } from "../../types/menu.types";

const CuposLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname;
  const value = path.includes(`${CUPOS_SUBNAV.basePath}/cliente`)
    ? "cliente"
    : path.includes(`${CUPOS_SUBNAV.basePath}/producto`)
      ? "producto"
      : CUPOS_SUBNAV.tabs[0]?.segment ?? "producto";

  const handleChange = (_: React.SyntheticEvent, next: string) => {
    navigate(`${CUPOS_SUBNAV.basePath}/${next}`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Cupos
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Gestión de cupos por producto y por cliente.
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          sx={{
            width: "100%",
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1.05rem",
              minHeight: 56,
              py: 1.5,
            },
          }}
        >
          {CUPOS_SUBNAV.tabs.map((t) => (
            <Tab key={t.segment} label={t.label} value={t.segment} />
          ))}
        </Tabs>
      </Box>
      <Outlet />
    </motion.div>
  );
};

export default CuposLayout;
